export default "__VITE_ASSET__5331b957__"